import { yupResolver } from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import { createUserOrUpdateUser, resetUser, verifyUserOTP } from '../../features/user/user.slice';

import {
  createSubmition,
  resetSubmition,
  saveSubmition,
  updateSubmition,
} from '../../features/submition/submition.slice';
import PrimaryButton from '../ui/buttons/primaryButton';
import Form from '../ui/forms';
import Input from '../ui/forms/fields/input';
import { resetData } from '../../features/data/data.slice';
import { resetSteps } from '../../features/stepper.slice';
import { useNavigate } from 'react-router-dom';
import { useGA4React } from 'ga-4-react';
import { Report } from '../../libs/loggers';

const useStyles = makeStyles((theme) => ({
  dialog: {
    minHeight: '250px',
    background: theme.palette.mode === 'light' ? '#fff' : '#373434',
  },
  listItem: {
    background: theme.palette.mode === 'light' ? '#EAE8E4' : '#2E2A2B',
    paddingRight: '16px',
    paddingLeft: '16px',
    marginBottom: '16px',
    overflow: 'hidden',
  },
  continueButton: {
    margin: 'auto',
    borderRadius: '10px',
  },

  closeButton: {
    position: 'absolute',
    top: 5,
    right: 5,
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'end',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  otptitle: {
    marginTop: '20px',
    marginBottom: '20px',
    textAlign: 'center',
  },
  textButton: {
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'flex',
    justifyContent: 'center',
    padding: '16px',

    marginBottom: '16px',
    cursor: 'pointer',
    textAlign: 'center',
    width: '75%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      paddingRight: '5px',
      paddingLeft: '5px',
    },
    background: theme.palette.mode === 'light' ? '#000000' : '#FFFFFF',
    color: theme.palette.mode === 'light' ? '#FFFFFF' : '#000000',
  },
  tick: {
    color: '#d59066',
    marginTop: '20px',
    width: '200px',
    [theme.breakpoints.down('sm')]: {
      width: '150px',
    },
    height: 'auto',
    margin: 'auto',
  },
  title: {
    marginTop: '30px',
    marginBottom: '20px',
    textAlign: 'center',
  },
  backDrop: {
    backdropFilter: 'blur(5px)',
    backgroundColor: 'rgba(0,0,0,0.4)',
  },
}));

export default function SaveProcess(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const ga4 = useGA4React();

  const logEvent = (action, label, category) => {
    ga4.event(action, label, category);
  };

  const loading = useSelector((state) => state.user.user.loading);
  const userId = useSelector((state) => state.user.user.userId);
  const user = useSelector((state) => state.user.user);
  const [open, setOpen] = useState(false);
  const [seconds, setSeconds] = useState(0);

  const [showOtp, setShowOtp] = useState(false);
  const [userIsVerified, setUserIsverified] = useState(false);
  const validationSchema = yup.object().shape({
    email: yup.string(),
    otp: yup.string(),
  });
  const requireHelp = useSelector((state) => state.stepper.value.requireHelp);
  const stepper = useSelector((state) => state.stepper.value);
  const formStepper = useSelector((state) => state.formStepper.value);
  const formStepperSteps = useSelector((state) => state.formStepper.value.formSectionsSteps);
  const email = useSelector((state) => state.user.user.email);
  const data = useSelector((state) => state.data.value);
  const submitionData = useSelector((state) => state.submition.data);
  let page = window.location.pathname.replace(/^\/|\/$/g, '');
  const submitionId = useSelector((state) => state.submition.submition?.submitionId);
  const {
    watch,
    setValue,
    register,
    handleSubmit,
    control,
    reset,
    getValues,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    resolver: yupResolver(validationSchema),
  });

  const otp = watch('otp');

  useEffect(() => {
    register('userId');
    setValue('userId', userId);
  }, [otp]);

  useEffect(() => {
    let countdown = null;
    if (seconds > 0) {
      countdown = setInterval(() => setSeconds(seconds - 1), 1000);
    } else {
      clearInterval(countdown);
    }
    return () => clearInterval(countdown);
  }, [seconds]);

  const handleOpen = () => {
    logEvent('click', 'save', `application`);
    const eventInfo = {
      action: 'click',
      category: 'application-save',
      description: 'open save application',
      value: {
        currentPage: page,
        step: stepper.active + 1,
        value: 'save',
      },
    };
    Report(eventInfo, userId, submitionId);
    props.openSave();
    setOpen(true);
  };
  const handleClose = () => {
    const desscrition = props.saveAndExit ? 'save and exit' : 'save and continue';

    const exit = props.saveAndExit ? 'exit' : 'continue';
    const value = userIsVerified ? `save_${exit}_application` : 'canceled';
    const eventInfo = {
      action: 'click',
      category: 'application-save',
      description: desscrition,
      value: {
        currentPage: page,
        step: stepper.active + 1,
        value: value,
      },
    };
    Report(eventInfo, userId, submitionId);
    logEvent('close', 'save_application_popup', `application`);
    if (props.saveAndExit && userIsVerified) {
      dispatch(resetSubmition());
      dispatch(resetData());
      dispatch(resetSteps());
      dispatch(resetUser());
      navigate('/');
    }

    props.closeSave();
    setOpen(false);
  };

  const onEmailSubmit = async (props) => {
    logEvent('submit', 'save_application', `email`);
    const eventInfo = {
      action: props.resend ? 'click' : 'submit',
      category: 'application-save',
      description: props.resend ? 'Clicked resend otp in save' : 'Submit email in save',
      value: {
        currentPage: page,
        step: stepper.active + 1,
        value: props.resend ? 'resend_otp' : 'submit_emial',
      },
    };
    Report(eventInfo, userId, submitionId);
    const data = await getValues();
    dispatch(createUserOrUpdateUser(data))
      .unwrap()
      .then(() => {
        setShowOtp(true);
        setSeconds(60);
      });
  };

  const onOTPSubmit = async () => {
    logEvent('verify', 'save_application', `otp`);
    const eventInfo = {
      action: 'submit',
      category: 'application-save',
      description: 'Submit email in save',
      value: {
        currentPage: page,
        step: stepper.active + 1,
        value: 'submit_otp',
      },
    };
    Report(eventInfo, userId, submitionId);

    const verificationData = await getValues();

    const submition = {
      email: email,
      userId: verificationData.userId,
      completeProcess: false,
      requireHelp: requireHelp,
      ...submitionData,
    };

    await dispatch(verifyUserOTP(verificationData))
      .unwrap()
      .then(async (res) => {
        dispatch(saveSubmition(submition));
        try {
          if (!submition._id) {
            //Create Submition
            await dispatch(
              createSubmition({
                ...submition,
                ...data,
              })
            )
              .unwrap()
              .then((originalPromiseResult) => {
                setUserIsverified(true);
              })
              .catch(() => {});
          } else {
            await dispatch(
              updateSubmition({
                ...submition,
                ...data,
                submitionId: submition._id,
              })
            )
              .unwrap()
              .then((originalPromiseResult) => {
                setUserIsverified(true);
              })
              .catch(() => {});
          }
        } catch (err) {
          console.log(err);
        }
      });
  };

  const userEmail = () => {
    return (
      <>
        <DialogContent className={classes.dialogContent}>
          <Typography variant="h4" className={classes.title}>
            Please enter your email address so we can <br />
            save your application and send you a <br />
            verification code to continue
          </Typography>
          <Form>
            <Input {...register('email')} fullWidth label="Email" variant="outlined" />
          </Form>
          <Box display={'flex'} marginTop="20px">
            <PrimaryButton
              size={'large'}
              className={classes.continueButton}
              onClick={() => onEmailSubmit({ resend: false })}
            >
              {'Submit'}
              {loading && <CircularProgress sx={{ ml: 2 }} size={20} color="inherit" />}
            </PrimaryButton>
          </Box>
        </DialogContent>
      </>
    );
  };

  const userOTP = () => {
    let time;
    seconds > 0 ? (time = `(${seconds})`) : (time = '');
    return (
      <>
        <DialogContent className={classes.dialogContent}>
          <TaskAltOutlinedIcon className={classes.tick} />
          <Typography variant="h5" className={classes.otptitle}>
            Thank you, an OTP has been sent to this email address.
            <br /> Please insert the OTP to verify your email address.
          </Typography>
          <Form>
            <Input {...register('otp')} fullWidth label="OTP" variant="outlined" />
          </Form>
          <Box display={'flex'} justifyContent={'center'} marginTop={'30px'}>
            <PrimaryButton
              size={'large'}
              disabled={seconds > 0}
              variant={'outlined'}
              sx={{ borderRadius: '10px', mr: 2 }}
              onClick={() => onEmailSubmit({ resend: true })}
            >
              {`Resend otp ${time}`}
            </PrimaryButton>
            <PrimaryButton size={'large'} sx={{ borderRadius: '10px' }} onClick={onOTPSubmit}>
              {'Submit'}
            </PrimaryButton>
            <Box display={'flex'} mt={'auto'} mb={'auto'}>
              {loading && <CircularProgress sx={{ ml: 2 }} size={20} color="inherit" />}
            </Box>
          </Box>
        </DialogContent>
      </>
    );
  };

  const userVerified = () => {
    return (
      <>
        <DialogContent className={classes.dialogContent}>
          <TaskAltOutlinedIcon color="primary" className={classes.tick} />
          <Typography variant="h4" className={classes.otptitle}>
            Your email has been verified,
            <br /> your progress will now be saved.
          </Typography>
          <Box display={'flex'} marginTop={'20px'}>
            <PrimaryButton
              size={'large'}
              className={classes.continueButton}
              onClick={() => {
                handleClose();
              }}
            >
              {'Continue'}
              {loading && <CircularProgress sx={{ ml: 2 }} size={20} color="inherit" />}
            </PrimaryButton>
          </Box>
        </DialogContent>
      </>
    );
  };

  return (
    <>
      {/* <Button onClick={() => handleOpen()} sx={{ mr: 1 }} size="medium">
        Save Process
      </Button> */}
      <Dialog
        fullWidth
        open={(props.open && props.open) || open}
        onClose={handleClose}
        PaperProps={{ classes: { root: classes.dialog } }}
        BackdropProps={{
          classes: {
            root: classes.backDrop,
          },
        }}
      >
        <IconButton
          size="large"
          aria-label="close"
          onClick={handleClose}
          className={classes.closeButton}
        >
          <CloseIcon fontSize="meduim" />
        </IconButton>
        {userIsVerified ? userVerified() : showOtp ? userOTP() : userEmail()}
      </Dialog>
    </>
  );
}
